import { combineReducers } from 'redux';

import { advisoryUiReducer } from './advisory/advisory.reducer';
import type { UiPanelState } from './model';
import { quoteActionsUiReducer } from './quoteActions/quoteActions.reducer';
import { quoteDetailUiReducer } from './quoteDetail/quoteDetail.reducer';
import { regulationUiReducer } from './regulation/regulationUi.reducer';
import { sidePanelUiReducer } from './sidePanelUi/sidePanelUi.reducer';
import { tradeConfirmationsReducer } from './tradeConfirmation/tradeConfirm.reducer';
export const UiPanelReducer = combineReducers<UiPanelState>({
  advisoryUi: advisoryUiReducer,
  quoteDetailUi: quoteDetailUiReducer,
  regulationUi: regulationUiReducer,
  sidePanelUi: sidePanelUiReducer,
  tradeConfirmations: tradeConfirmationsReducer,
  quoteActionsUi: quoteActionsUiReducer,
});
